import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home.vue'
import postmortem from './views/postmortem.vue'
import identitaet from './views/identitaet.vue'
import blackmountain from './views/blackmountain.vue'
import premedicatedmurder from './views/premedicatedmurder.vue'
import trashytrash from './views/trashytrash.vue'
import imprint from './views/imprint.vue'
import untitled from './views/untitled.vue'
import derigel from './views/derigel.vue'
import mountainandmaiden from './views/mountainandmaiden.vue'
import meter from './views/153METER.vue'



Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/blackmountain/',
      name: 'blackmountain',
      component: blackmountain
    },
    {
      path: '/mountainmaiden/',
      name: 'mountainandmaiden',
      component: mountainandmaiden
    },
    {
      path: '/premedicatedmurder/',
      name: 'premedicatedmurder',
      component: premedicatedmurder
    },
    {
      path: '/imprint/',
      name: 'imprint',
      component: imprint
    },
    {
      path: '/untitled/',
      name: 'untiteld',
      component: untitled
    },
    {
      path: '/derigel/',
      name: 'derigel',
      component: derigel
    },
    {
      path: '/postmortem/',
      name: 'postmortem',
      component: postmortem
    },
    {
      path: '/153METER/',
      name: '154meter',
      component: meter
    },
  ]
})
